import { Badge, Box, Divider, Flex, Heading, Icon, Link, Text } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

import { MAIN_NUMBER } from '../../../../constants/contact';
import { PayoffRequest } from '../../../../gql/generated/graphql';
import { formatDateToString } from '../../../../utils/dates';
import { formatMoney } from '../../../../utils/helpers';

const SuccessPayoff = ({ payoffRequest }: { payoffRequest: PayoffRequest }) => {
  return (
    <Box>
      <Flex mb={4}>
        <Box mr={4}>
          <Flex
            boxSize={8}
            rounded="full"
            p={1}
            bgColor="green.100"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={FaCheckCircle} color="green.500" />
          </Flex>
        </Box>
        <Box>
          <Badge variant="outline" colorScheme="green" my={2}>
            PAYOFF CONFIRMED
          </Badge>
          <Text color="gray.600">YOUR OFFICIAL PAYOFF AMOUNT</Text>
          <Heading as="h3" fontSize="xxx-large" fontWeight="bold">
            {formatMoney(payoffRequest.vehicle_payoff)}
          </Heading>
          <Text>
            Valid through:{' '}
            <Text as="span" fontWeight="bold">
              {formatDateToString(payoffRequest.good_through_date)}
            </Text>
          </Text>
        </Box>
      </Flex>
      <Divider my={4} />
      <Text fontSize="sm" color="gray.600">
        Your payoff may or may not include taxes depending on your lender. We're reviewing
        everything to keep your buyout moving and will reach out soon with next steps. Want to talk
        sooner? Call us anytime at <Link href={`tel:+1-${MAIN_NUMBER}`}>{MAIN_NUMBER}</Link>
      </Text>
    </Box>
  );
};

export default SuccessPayoff;
